const sessionTokenStorage = localStorage.getItem("session_token");

export const apiHeader = {
  Authorization: `Bearer ${sessionTokenStorage}`,
};

export const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
